import { ButtonGroup, Icon, IconButton } from "@mui/material";

type Props = {
    onCommand: (command: string) => void;
};

const JustifyButtons = ({ onCommand }: Props) => (
    <ButtonGroup disableElevation color="inherit" variant="contained" size="small">
        <IconButton title="Justify Left" color="inherit" onClick={() => onCommand('justifyleft')}>
            <Icon>format_align_left</Icon>
        </IconButton>
        <IconButton title="Justify Center" color="inherit" onClick={() => onCommand('justifycenter')}>
            <Icon>format_align_center</Icon>
        </IconButton>
        <IconButton title="Justify Right" color="inherit" onClick={() => onCommand('justifyright')}>
            <Icon>format_align_right</Icon>
        </IconButton>
        <IconButton title="Justify Full" color="inherit" onClick={() => onCommand('justifyfull')}>
            <Icon>format_align_justify</Icon>
        </IconButton>
    </ButtonGroup>
);

export default JustifyButtons;
